import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';


import { getTicketLink } from '../../ticketViewer/links';


const propTypes = exact({
  tickets: PropTypes.array.isRequired,
});


const style = {
  maxHeight: '5em',
  overflowY: 'scroll',
};


const CompactTicketList = (props) => {
  const { tickets } = props;

  return (
    <ul style={style}>
      {tickets.map((ticket) => {
        const { job_id: jobId, id: ticketId } = ticket;
        const ticketLink = getTicketLink(ticketId, jobId);
        return (
          <li key={ticketId}>
            <Link to={ticketLink}>{ticket.ticket_number.number}</Link>
          </li>
        );
      })}
    </ul>
  );
};


CompactTicketList.propTypes = propTypes;


export default CompactTicketList;
